module.exports = __webpack_public_path__ + "img/cocopay-logo-colored.66544f4b.png";